import AbstractController from '../src/services/ControllersRepository/AbstractController';
import MaterialCreateForm from '@views/materials/MaterialCreateForm';
import MaterialUpdateForm from '@views/materials/MaterialUpdateForm';

export default class Materials extends AbstractController {
    protected controllerName = 'Materials';

    protected getDefaultCreateFormComponent() {
        return MaterialCreateForm;
    }

    protected getDefaultUpdateFormComponent() {
        return MaterialUpdateForm;
    }
}
